import { WalkIcon } from './WalkIcon';

/**
 * author: Google
 * id DA42DA16-21E0-4A08-89E4-F634EBBCF85A
 * name walk
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/walk.svg
 * tags
 * - Sport 
 * - Transportation + Other 
 * - People / Family 
 */
export const HumanWalkIcon = WalkIcon;
export default HumanWalkIcon